import { Row, Col, Form, Image, Card } from "react-bootstrap";
import React from "react";
import convertToBlob from "../../utilities/convertToBlob";

function ImagesForm(props) {
  // form for handling image uplaods and displaying already uploaded images
  // allows the user to add/delete multiple images at once

  return (
    <>
      <Form.Group controlId="images" className="mb-3 mt-3">
        <Form.Label>Add Image(s)</Form.Label>
        <Form.Control
          name="images"
          type="file"
          accept="image/*"
          multiple
          // adding new images
          onChange={async (event) => {
            let newImages = event.target.files;
            props.handleAddImages(newImages);
            props.handleChange({
              target: {
                name: "images",
                // add new image to formik's values.images
                value: [...props.images, ...newImages],
              },
            });
            event.target.value = ""; //reset image input field
          }}
          isInvalid={props.touched.images && !!props.errors.images}
        />
        <Form.Control.Feedback type="invalid">
          {props.errors.images}
        </Form.Control.Feedback>
      </Form.Group>

      {/* ALREADY ADDED IMAGES */}
      {props.images.length > 0 ? (
        <Card style={{ backgroundColor: "#fafafa" }}>
          <h6 style={{ color: "gray" }}>
            <b>Already added images</b>
          </h6>
          <Card.Body>
            <Row className="mb-3">
              {props.images.map((image, idx) => {
                let blob;
                if (!image?.public_id) {
                  blob = convertToBlob([image])[0];
                }
                return (
                  <Col key={idx} xs={2}>
                    {" "}
                    <div style={{ position: "relative" }}>
                      {image?.public_id ? (
                        <Image fluid src={image.url}></Image>
                      ) : (
                        <Image fluid src={URL.createObjectURL(blob)}></Image>
                      )}
                      <i
                        className="bi bi-x-circle"
                        style={{
                          color: "red",
                          position: "absolute",
                          top: 0,
                          left: 0,
                          transform: "translate(-50%, -50%)",
                          zIndex: "1",
                        }}
                        // remove image from Formik's state variable images
                        // and from prevUplaodedImages state variable
                        onClick={() => {
                          props.handleChange({
                            target: {
                              name: "images",
                              value: props.images.filter((item) => {
                                if (item?.public_id) {
                                  return item.public_id !== image.public_id;
                                } else {
                                  return item !== image;
                                }
                              }),
                            },
                          });
                          // delete from cloudinary later, in background
                          // props.deleteUploadedImage(image.public_id);
                          props.handleDeleteImage(image);
                        }}
                      ></i>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Card.Body>
        </Card>
      ) : null}
    </>
  );
}

export default React.memo(ImagesForm); //component will only rerender if its own props change, not every time parent rerenders
